export default {
  title: 'Come funzionano le commissioni di elaborazione',
  how_it_works:
    'Stripe addebita la sua commissione alla tua piattaforma per ogni pagamento online che i tuoi ristoranti ricevono. La commissione di elaborazione che imposti è quella che il ristorante paga per quel pagamento. Se è superiore a quella di Stripe, la differenza resta a te come margine. Se è inferiore, o se non ne imposti nessuna, la differenza la paghi tu.',
  stripe_rates_link: 'Vedi le tariffe standard di Stripe',
  example: {
    intro:
      'Esempio: un ordine da {{total}} pagato con carta. Stripe addebita alla tua piattaforma {{stripe_fee}} ({{stripe_rate}}).',
    above: 'La tua tariffa {{rate}}: il ristorante paga {{fee}}, a te restano {{difference}}.',
    below: 'La tua tariffa {{rate}}: il ristorante paga {{fee}}, tu paghi la differenza di {{difference}}.',
    none: 'Nessuna tariffa (margine 0%): il ristorante non paga nulla, tu paghi per intero {{stripe_fee}}.',
    disclaimer:
      'La commissione di Stripe qui indicata è la sua tariffa standard per carte nello SEE, a titolo illustrativo. La commissione effettiva dipende dalla carta, dal suo paese e dal tuo piano Stripe.',
  },
};
